import React from 'react'

import { Form, Col } from '_zari/core'

import { Select2UsuariosContabilidad } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

import { KeyEventUtil } from 'utils'

const TrabajadorFormGroup = ({
  iValue,
  vNombreUsuario,
  setIdUsuario,
  setNombreUsuario,
  setIdTituloViatico,
  ocultarSections,
  showClearButton = true
}) => {
  const onChangeUsuarioHandler = pickedUser => {
  setIdUsuario(pickedUser._id)
  setNombreUsuario(`${pickedUser.nombres} ${pickedUser.apellidos}`)
  ocultarSections()
  setIdTituloViatico('')

  setTimeout(() => {
    KeyEventUtil.leaveOnKeyEvent(`select-asignarDocs-tituloViatico`)
  }, 200)
}

  const clickClear = React.useCallback(() => {
    setIdUsuario('')
    setNombreUsuario('')
    ocultarSections()
    setIdTituloViatico('')

    KeyEventUtil.leaveOnKeyEvent('select2-asignarDocs-trabajador')
  }, [setIdUsuario, setNombreUsuario, ocultarSections, setIdTituloViatico])

  React.useEffect(() => {
    setTimeout(() => {
      KeyEventUtil.leaveOnKeyEvent(`select2-asignarDocs-trabajador`)
    }, 200)
  }, [])

  return (
    <>
      <Form.Group>
        <Form.Label text='TRABAJADOR' htmlFor='input-asignarDocs-trabajador' md={4} alignRightAt='md' />
        <Col md={8}>
                    { iValue ? (
            showClearButton ? (
              <ClearInputGroup
                id='input-asignarDocs-trabajador'
                iValue={vNombreUsuario}
                clickClear={clickClear}
              />
            ) : (
              <Form.InputText
                id='input-asignarDocs-trabajador'
                value={vNombreUsuario}
                disabled
              />
            )
          ) : (
            <Select2UsuariosContabilidad
              id='select2-asignarDocs-trabajador'
              onChange={onChangeUsuarioHandler}
            />
          )}
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(TrabajadorFormGroup)
